import React, { useContext } from 'react';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { getComputedStrokes } from '../../utils';
import { TextLayerContext } from '../context';

type Props = {
    href: string;
    layer: ILayerProps;
};

export const StrokeUse: React.FC<Props> = ({ href, layer }) => {
    const { defIDSuffix } = useContext(TextLayerContext)!;

    const { textStroke = [], textShadow = [] } = layer.data as ITextLayerProps;
    const strokes = getComputedStrokes(textStroke);

    if (strokes.length === 0) return null;

    return (
        <React.Fragment>
            {strokes.toReversed().map((stroke, idx) => {
                if (stroke.hidden) return null;

                // ATTENTION: 如果有阴影，那么描边的 filter 也需要应用阴影
                const shadow = textShadow[idx];
                const shadowFilter =
                    shadow && !shadow.hidden ? `url(#shadow-${layer.id}-${idx}-${defIDSuffix})` : undefined;

                return (
                    <use
                        key={`text-stroke-${layer.id}-${stroke.idx}`}
                        xlinkHref={href}
                        fill={stroke.color}
                        stroke={stroke.color}
                        strokeWidth={stroke.width * 2}
                        strokeLinejoin="round"
                        filter={shadowFilter}
                    />
                );
            })}
        </React.Fragment>
    );
};
